import React from "react";
import {
    Toaster,
    Position
} from "@blueprintjs/core";
import RandomString from "randomstring";
import { storage } from "../../../../fire";
import { shuffle } from "lodash";
import Loader from 'components/layout/loaders/Classic'
import {
    toast_deleteError,
    toast_deleteSuccess,
    toast_uploadError,
    toast_uploadInProgress,
    toast_uploadSuccess,
    toast_warningError
} from "../../Sequences/Toast";
import DialogAddResource from "../../Sequences/DialogAddResource";
import TableResources from "./TableResources";
import Auth from "../../../../services/Auth";
import Session from "../../../../services/Session";

class SequencesPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogIsOpen: false,
            isDeletingResource: false,
            submiting: false,
            resources: []
        };
    }

    handleOpenDialog = () => this.setState({ dialogIsOpen: true });

    handleCloseDialog = () => this.setState({
        dialogIsOpen: false,
        resources: []
    });

    handleChangeFileInput = e => {
        let files = []
        for (let i = 0; i < e.target.files.length; i++) {
            let newFile = e.target.files[i]
            let file = RandomString.generate(16);
            let name = newFile.name
            let blob = newFile

            let type

            if (newFile.type.includes('image')) {
                type = 'IMAGE'
            } else if (newFile.type.includes('video')) {
                type = 'VIDEO'
            } else {
                alert('File type not allowed')
            }

            files.push({ name: name, file: file, fileBlob: blob, type: type, downloadURL: null })

            if (i === e.target.files.length - 1) {
                this.setState({ resources: this.state.resources.concat(files) })
            }
        }
    };

    handleAddResource = () => {
        this.setState({ submiting: true });
        this.state.resources.forEach((resource) => {
            const { resources, changeResources, sessionId } = this.props;
            const uploadToastKey = this.toaster.show(toast_uploadInProgress(0));
            const storageRef = Session.addResource({
                sessionId,
                resource,
                onProgress: snapshot => {
                    /**
                     * Upload is in progress
                     * --
                     * Calculate purcentage of uploading
                     * Update the upload toast with the new purcentage
                     */
                    let progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );

                    this.toaster.show(toast_uploadInProgress(progress), uploadToastKey);
                },
                onError: e => {
                    /**
                     * Upload has errored
                     * --
                     * Set the new state (no more submiting and resrouce obj is reseted)
                     * Close the 'Télécharger une image' dialog
                     * Dismiss the upload toast
                     * Show an error toast
                     */
                    this.setState({
                        submiting: false,
                        resource: {
                            name: null,
                            file: null,
                            fileBlob: null,
                            downloadURL: null,
                            type: null
                        }
                    });
                    this.handleCloseDialog();
                    this.toaster.dismiss(uploadToastKey);
                    this.toaster.show(toast_uploadError());
                    console.error("An error has been occured when uploading\n", e.message);
                },
                onComplete: () => {
                    /**
                     * Upload is complete
                     * --
                     * Give an id to the resource (usefull for resource removing)
                     * Get the download URL of the uploaded file (async)
                     * Push the resource to the list of resource (omit the fileBlob attribute)
                     * Call prop handler 'onChangeResource' to update the list of resource of the parent component
                     * Set the new state (update list of resource, no more submiting and resource obj is reseted)
                     * Dismiss the upload toast
                     * Show a success toast
                     */
                    storageRef
                        .getDownloadURL()
                        .then(url => {
                            resource.downloadURL = url
                        })
                        .then(() => {
                            resources.push({
                                id: RandomString.generate(16),
                                name: resource.name,
                                file: resource.file,
                                downloadURL: resource.downloadURL,
                                type: resource.type
                            });
                            changeResources(this.props.number, resources);
                            this.setState({
                                submiting: false,
                                resource: {
                                    name: null,
                                    file: null,
                                    fileBlob: null,
                                    downloadURL: null,
                                    type: null
                                }
                            });
                            this.handleCloseDialog();
                            this.toaster.dismiss(uploadToastKey);
                            this.toaster.show(toast_uploadSuccess());
                        });
                }
            });
        })
    };

    handleDeleteResource = id => {
        let { resources } = this.props;
        const { handleReplacesResources, sessionId } = this.props;
        const storageRef = storage.ref(
            `sequences/${Auth.getUserId()}/${sessionId}/${resources.find(r => r.id === id).file
            }`
        );

        const deleteResource = () => {
            // Delete the element that has the given id using Array.filter
            resources = resources.filter(r => r.id !== id);
            // this.removeSequencesWithResource(id);
            handleReplacesResources(this.props.number, resources);
        };

        this.setState({ isDeletingResource: true });
        storageRef
            .delete()
            .then(() => {
                this.toaster.show(toast_deleteSuccess());
                deleteResource();
                this.setState({ isDeletingResource: false });
            })
            .catch(e => {
                const { code } = e;

                this.setState({ isDeletingResource: false });
                switch (code) {
                    case "storage/unknown":
                        this.toaster.show(
                            toast_deleteError("Unknow error occurred...")
                        );
                        break;
                    case "storage/object-not-found":
                        this.toaster.show(
                            toast_warningError(
                                "File not fown, we still deleted the resource.",
                                10000
                            )
                        );
                        deleteResource();
                        break;
                    case "storage/quota-exceeded":
                        this.toaster.show(
                            toast_deleteError("Allocated storage space is full.")
                        );
                        break;
                    case "storage/unauthenticated":
                        this.toaster.show(
                            toast_deleteError("Please login !")
                        );
                        break;
                    default:
                        this.toaster.show(toast_deleteError(e.message));
                        break;
                }
            });
    };

    handleEditResource = (value, name, id) => {
        let resources = this.props.resources
        resources[id].name = value

        this.props.changeResources(this.props.number, resources)
    }

    handleGenerateSequences = (shiftBeforeGenerate = false) => {
        let { protocol, sequences, resources, onChangeSequences } = this.props;
        const generateSequencesForProtocolMSAndMC = () =>
            resources.forEach(r =>
                sequences.push({ id: RandomString.generate(16), resources: [r] })
            );
        const generateSequencesForProtocolPC = () => {
            for (let i = 0; i < resources.length - 1; i++)
                for (let j = i + 1; j < resources.length; j++)
                    sequences.push({
                        id: RandomString.generate(16),
                        resources: [resources[i], resources[j]]
                    });
        };

        if (shiftBeforeGenerate) sequences = [];
        switch (protocol) {
            case "PC":
                if (resources.length <= 1)
                    this.toaster.show(
                        toast_warningError(
                            "The protocol you chosed require at least 2 images to generate sequences."
                        )
                    );
                generateSequencesForProtocolPC();
                break;
            case "CM":
                if (resources.length <= 1)
                    this.toaster.show(
                        toast_warningError(
                            "The protocol you chosed require at least 2 images."
                        )
                    );
                generateSequencesForProtocolPC();
                break;
            case "MS":
                generateSequencesForProtocolMSAndMC();
                break;
            case "MC":
                generateSequencesForProtocolMSAndMC();
                break;
            default:
                this.toaster.show(
                    toast_warningError(
                        "Unknow protocol, impossible to generate sequences"
                    )
                );
                return;
        }
        if (sequences.length === 0) return;
        onChangeSequences(sequences);
    };


    handleShuffleSequences = () => this.props.onChangeSequences(shuffle(this.props.sequences));

    handleDeleteSequence = id => {
        let { sequences, onChangeSequences } = this.props;

        // Delete the element that has the given id using Array.filter
        sequences = sequences.filter(s => s.id !== id);
        onChangeSequences(sequences);
    };

    handleAddSequence = () => {
        const { sequences = [], onChangeSequences } = this.props;

        sequences.push({
            id: RandomString.generate(16),
            resources: []
        });
        onChangeSequences(sequences);
    };

    handleAddChannelToSequence = (sequenceId, channel) => {
        const { sequences = [], onChangeSequences } = this.props;
        const indexOfSequence = sequences.findIndex(s => s.id === sequenceId);
        let targetedSequence = null;

        if (indexOfSequence == null)
            return console.warning(
                "Cannot find by id a sequence in the list of sequence"
            );
        targetedSequence = sequences[indexOfSequence];
        if (!targetedSequence.resources) targetedSequence.resources = [];
        targetedSequence.resources.push({ ...channel });

        // targetedSequence is a reference
        // we don't need to `sequences[indexOfSequence] = targetedSequence`
        onChangeSequences(sequences);
    };

    handleRemoveChannelFromSequence = (sequenceId, ifOfChannelToRemove) => {
        const { sequences = [], onChangeSequences } = this.props;
        const indexOfSequence = sequences.findIndex(s => s.id === sequenceId);
        let targetedSequence = null;

        if (indexOfSequence == null)
            return console.warning(
                "Cannot find by id a sequence in the list of sequence"
            );
        targetedSequence = sequences[indexOfSequence];
        if (!targetedSequence.resources)
            return console.warning(
                "Trying to remove a channel but no channels are set"
            );
        targetedSequence.resources = targetedSequence.resources.filter(
            channel => channel.id !== ifOfChannelToRemove
        );
        // targetedSequence is a reference
        // we don't need to `sequences[indexOfSequence] = targetedSequence`
        onChangeSequences(sequences);
    };

    render() {
        const {
            resources,
            instances = [],
        } = this.props;
        const {
            dialogIsOpen,
            submiting,
            isDeletingResource
        } = this.state;

        return (
            <div>
                <Toaster
                    position={Position.TOP_RIGHT}
                    autoFocus={false}
                    ref={toaster => (this.toaster = toaster)}
                />
                <DialogAddResource
                    resources={this.state.resources}
                    dialogIsOpen={dialogIsOpen}
                    submiting={submiting}
                    onChangeFileInput={this.handleChangeFileInput}
                    onCloseDialog={this.handleCloseDialog}
                    onAddResource={this.handleAddResource}
                />
                {(this.state.isDeletingResource || this.props.loadingDelete) ?
                    <Loader />
                    :
                    <TableResources
                        number={this.props.number}
                        instances={instances}
                        resources={resources}
                        onDeleteResource={this.handleDeleteResource}
                        deleting={isDeletingResource}
                        onOpenDialog={this.handleOpenDialog}
                        attributes={this.props.attributes}
                        handleEditResource={this.handleEditResource}
                        handleChangeAttribute={this.props.handleChangeAttribute}
                        handleChangeAttributeUnitValue={this.props.handleChangeAttributeUnitValue}
                        handleDeleteAttribute={this.props.handleDeleteAttribute}
                        handleChangeSequencesResourcesCM={this.props.handleChangeSequencesResourcesCM}
                    />
                }
            </div>
        );

    }
}

export default SequencesPanel;
